export const API_REQUEST_FULLFILLED = "fulfilled";
export const MESSAGE_NOT_A_VALUE = "##NOT_A_VALUE##";
export const MESSAGE_PROCESSING_DETAILS = "Processing details...";
export const MESSAGE_BACK_TO_PREVIOUS_STEP = "Back to previous step";
export const MESSAGE_SAVE_AND_CONTINUE = "Save and continue";
export const MESSAGE_NEXT = "Next";
export const MESSAGE_SUBMIT = "Submit";